import { useContext } from 'react';
import { createContext } from 'react';

import { TabLayoutProps } from '../@types/TabLayoutProps';

export const TabLayoutContext = createContext<TabLayoutProps>({} as TabLayoutProps);

TabLayoutContext.displayName = 'TabLayout';

const TabLayoutProvider = (props: TabLayoutProps) => (
	<TabLayoutContext.Provider value={props}>{props.children}</TabLayoutContext.Provider>
);

export const useTabLayout = () => {
	const context = useContext(TabLayoutContext);

	return context;
};

export default TabLayoutProvider;
